export default __webpack_public_path__ + "e092f3307bdc2212ae86e98892d966ef.svg";